import isFashionUnitedSite from './isFashionUnitedSite';

const origin = isFashionUnitedSite() ?
  `${window.location.origin}/` : 'https://fashionunited.com/';

export default url => url && url.replace(/^\/(?!\/)/, origin);
